import { useEffect, useState } from 'react';

/**
 * Tracks page scroll as a 0..1 fraction for the top progress bar.
 *
 * This is now a FALLBACK path only. Modern browsers drive the progress bar with
 * a pure CSS scroll timeline (see `.scroll-progress` in motion.css), so App.tsx
 * passes `enabled = false` there and this hook never attaches a listener — which
 * avoids a `setState` on every scroll event re-rendering the whole App tree.
 * When `enabled` is false the hook is inert and returns 0.
 */
export function useScrollProgress(enabled = true): number {
  const [pct, setPct] = useState(0);
  useEffect(() => {
    if (!enabled) return;
    const tick = () => {
      const h = document.documentElement;
      const max = h.scrollHeight - h.clientHeight;
      setPct(max > 0 ? h.scrollTop / max : 0);
    };
    window.addEventListener('scroll', tick, { passive: true });
    tick();
    return () => window.removeEventListener('scroll', tick);
  }, [enabled]);
  return pct;
}
